<template>
  <div>
    <PublicLayout>
      <header
        class="header"
        :style="{
          backgroundImage: `url(${require('@/assets/public/images/news/header.jpg')})`,
        }"
      >
        <div class="container">
          <h1>最新消息</h1>
        </div>
      </header>
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <div class="public-news-list">
              <router-link
                v-for="news in newsList"
                :key="news.id"
                :to="`/news/${news.id}`"
                class="public-news-list-item"
              >
                <div>
                  <span class="public-news-tag mr-2">{{ news.category }}</span>
                  <span class="public-news-list-item-date">
                    {{ news.publishedAt | moment("YYYY年MM月DD日") }}</span
                  >
                </div>
                <div>
                  <h4>{{ news.title }}</h4>
                </div>
              </router-link>
            </div>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import moment from "moment";
import db from "../../api/db";
export default {
  name: "PublicNewsScreen",
  components: {
    PublicLayout,
  },
  data() {
    return {
      newsList: [],
    };
  },
  methods: {
    formatDate(ts, format) {
      return moment(ts).format(format);
    },
  },
  mounted() {
    const vm = this;
    const newsList = [];
    const newsCategoryMap = {};
    async function fetchData() {
      const newsCategoryListCollection = await db
        .collection("newsCategoryList")
        .get();
      newsCategoryListCollection.forEach((doc) => {
        const categoryTitle = doc.data().title;
        newsCategoryMap[doc.id] = categoryTitle;
      });

      const collection = await db
        .collection("newsList")
        .where("isPublished", "==", true)
        .orderBy("publishedAt", "desc")
        .get();
      collection.forEach((doc) => {
        const news = doc.data();
        news.category = newsCategoryMap[news.category];
        news.id = doc.id;
        newsList.push(news);
      });
      vm.newsList = newsList;
    }
    fetchData();
  },
};
</script>